// extracted by mini-css-extract-plugin
export default {"cls1":"qZCZ2A2Pz1qI8l7Z3P08","cls2":"_EZISjb54kFlvYtwkFwp qZCZ2A2Pz1qI8l7Z3P08","isTablet":"tXnYf5tESyzvWdWpmmj6","isPhone":"ybUOuUh7fmh3R8Q9P1cP"};